import { render, staticRenderFns } from "./checkout-guide.component.vue?vue&type=template&id=3c6ed714"
import script from "./checkout-guide.component.vue?vue&type=script&lang=js"
export * from "./checkout-guide.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports